import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http';
import { empty, BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var FileUploadService = /** @class */ (function () {
    function FileUploadService(http) {
        this.http = http;
    }
    FileUploadService.prototype.Upload = function (url, files) {
        var _this = this;
        // Prepare a map of observables showing the file progress for each file being uploaded
        var filestatus = [];
        files.forEach(function (file, idx) {
            // Create a new multi-part form for every file being uploaded.
            var formData = new FormData();
            formData.append('file', file.File, file.File.name);
            // Append any/all parameters for the form data as well.
            if (file.Parameters != null) {
                var params = Object.entries(file.Parameters);
                if (params && !!params.length) {
                    params.forEach(function (entry) {
                        formData.append(entry[0], entry[1]);
                    });
                }
            }
            // Set the http Headers
            var headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
            // Create an http-post request and pass the form, while telling the request to report upload
            // progress.
            var req = new HttpRequest('POST', url, formData, {
                //                headers: headers,
                reportProgress: true
            });
            // Create a new progress Subject for every file.
            var progress = new BehaviorSubject({
                FileName: file.File.name,
                PercentComplete: 0,
                Error: null,
                isError: false,
                isComplete: false,
                isInProgress: true,
                UploadID: idx
            });
            // Send the http-post request and subscribe for progress updates on it.
            _this.http.request(req).subscribe(function (event) {
                if (event.type === HttpEventType.UploadProgress) {
                    // Calculate the progress percentage.
                    var percentDone = Math.round(100 * event.loaded / event.total);
                    // Update the progress BehaviorSubject with the new calculation.
                    var newentry = tslib_1.__assign({}, progress.value);
                    newentry.PercentComplete = percentDone;
                    progress.next(newentry);
                }
                else if (event instanceof HttpResponse) {
                    // Close the progress BehaviorSubject as the upload is now complete.
                    var oldval = tslib_1.__assign({}, progress.value);
                    oldval.isComplete = true;
                    oldval.isInProgress = false;
                    // Set the final file information so the client can update the UI.
                    var fileInfo = event.body;
                    oldval.FinalFileInfo = (fileInfo && fileInfo[0]);
                    if (oldval.FinalFileInfo) {
                        oldval.FinalFileInfo.DateUploaded = (oldval.FinalFileInfo.DateUploaded ?
                            new Date(oldval.FinalFileInfo.DateUploaded) : null);
                    }
                    // Send out one more update before closing it.
                    progress.next(oldval);
                    progress.complete();
                }
            }, function (error) {
                var oldval = tslib_1.__assign({}, progress.value);
                oldval.Error = error.error;
                oldval.isError = true;
                oldval.isInProgress = false;
                progress.error(oldval);
            }, function () {
            });
            // Store the progress observables in the array.
            filestatus.push(progress.pipe(catchError(function (err) {
                return empty();
            })));
        });
        // Return the progress map
        return filestatus;
    };
    FileUploadService.ngInjectableDef = i0.defineInjectable({ factory: function FileUploadService_Factory() { return new FileUploadService(i0.inject(i1.HttpClient)); }, token: FileUploadService, providedIn: "root" });
    return FileUploadService;
}());
export { FileUploadService };
// #region Custom Classes
// #region File Upload Information
var FileUploadInformation = /** @class */ (function () {
    function FileUploadInformation() {
    }
    return FileUploadInformation;
}());
export { FileUploadInformation };
// #endregion
// #region File Upload Status Info
var FileUploadStatusInfo = /** @class */ (function () {
    function FileUploadStatusInfo() {
    }
    return FileUploadStatusInfo;
}());
export { FileUploadStatusInfo };
